import { useEffect, useState } from "react";
import { fontFaceKey } from "./FontPairingSystemV2";

export default function useTypographyFontFacesV1(systems) {
  const [status, setStatus] = useState({});
  const entries = systems.flatMap((system) => Object.values(system?.roles || {})).filter((entry) => !entry.font.uploaded);
  const key = [...new Set(entries.map(fontFaceKey))].sort().join("|");
  useEffect(() => {
    if (!key) return undefined;
    let cancelled = false;
    const unique = [...new Map(entries.map((entry) => [fontFaceKey(entry), entry])).values()];
    const families = new Map();
    unique.forEach((entry) => {
      const variants = families.get(entry.font.family) || new Set();
      variants.add(`${entry.treatment.font_style === "italic" ? 1 : 0},${entry.treatment.font_weight || 400}`);
      families.set(entry.font.family, variants);
    });
    const href = "https://fonts.googleapis.com/css2?" + [...families].map(([family, variants]) =>
      "family=" + encodeURIComponent(family).replace(/%20/g, "+") + ":ital,wght@" + [...variants].sort().join(";")
    ).join("&") + "&display=swap";
    setStatus(Object.fromEntries(unique.map((entry) => [fontFaceKey(entry), "loading"])));
    const link = document.createElement("link");
    link.rel = "stylesheet"; link.href = href;
    const fail = () => { if (!cancelled) setStatus(Object.fromEntries(unique.map((entry) => [fontFaceKey(entry), "error"]))); };
    const timer = setTimeout(fail, 15000);
    link.onerror = fail;
    link.onload = async () => {
      const loaded = await Promise.all(unique.map(async (entry) => {
        try {
          const faces = await document.fonts.load(`${entry.treatment.font_style || "normal"} ${entry.treatment.font_weight || 400} 18px "${entry.font.family}"`, entry.font.scripts?.includes("cyrillic") ? "Красота Beauty" : "Beauty");
          return [fontFaceKey(entry), faces.length ? "ready" : "error"];
        } catch { return [fontFaceKey(entry), "error"]; }
      }));
      if (!cancelled) { clearTimeout(timer); setStatus(Object.fromEntries(loaded)); }
    };
    document.head.appendChild(link);
    return () => { cancelled = true; clearTimeout(timer); link.remove(); };
    // The sorted identity covers every requested family, real weight and style.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
  return status;
}


